// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2KRyS","productName":"Table_productName__fkjt9"};